import cookie from 'cookie';
import { FALLBACK_LANGUAGE, FALLBACK_MARKETPLACE } from './constants';
export const getLanguageFromRequest = (req) => {
    var _a, _b, _c;
    // Try User-Language header first
    const headerLang = (_a = req.headers) === null || _a === void 0 ? void 0 : _a['user-language'];
    if (headerLang) {
        return headerLang;
    }
    // Try cookie second
    if ((_b = req.headers) === null || _b === void 0 ? void 0 : _b.cookie) {
        const requestCookies = cookie.parse((_c = req.headers) === null || _c === void 0 ? void 0 : _c.cookie);
        const cookieLang = requestCookies['NEXT_LOCALE'];
        if (cookieLang) {
            return cookieLang;
        }
    }
    // Fallback to fr-FR
    return FALLBACK_LANGUAGE;
};
export const getMarketplaceFromRequest = (req) => {
    var _a, _b;
    // Try Marketplace header first
    const marketplaceHeader = (_a = req.headers) === null || _a === void 0 ? void 0 : _a.marketplace;
    if (marketplaceHeader) {
        return marketplaceHeader;
    }
    const localeCookie = ((_b = req.headers) === null || _b === void 0 ? void 0 : _b.cookie) && cookie.parse(req.headers.cookie)['MP'];
    if (localeCookie) {
        return localeCookie;
    }
    // Fallback to fr
    return FALLBACK_MARKETPLACE;
};
